@if (model) {
    @if (!isLoading) {
        <datamanagement-linkable
            #linkableProcessingPurpose
            typename="processing purpose"
            displayValueProp="name"
            [linked]="linked"
            [unlinked]="unlinked"
            [orderByValueProperty]="true"
            (linkedChange)="linkedItemsChanged($event)"
        >
        </datamanagement-linkable>
    } @else {
        <div class="fancy-loader"></div>
    }
}
